export function parseAttributeAsBoolean(attribute: boolean | string): boolean {
  if (typeof attribute === "string") {
    return attribute?.toLowerCase() !== "false";
  }
  return Boolean(attribute);
}
